import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { userLogout } from "../appRedux/actions/Auth";
import { useNavigate } from "react-router-dom";
const Logout = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(userLogout());
    navigate("/login");
  });

  return <></>;
};

export default Logout;
